import { getArticleLabel } from '../hooks/useConsumptionArticles';

/**
 * Nombre y código del artículo de un renglón de consumo para la celda de dos líneas.
 * @param {Object} articlesByUuid Artículos cargados por UUID.
 * @param {Object} item Renglón del consumo.
 * @returns {{name: string, code: string}}
 */
export const getConsumptionItemArticleParts = (articlesByUuid, item) => {
  const article = articlesByUuid[item.uuid_inventory_article];
  if (!article) {
    return {
      name: item.article_name || getArticleLabel(articlesByUuid, item.uuid_inventory_article),
      code: item.article_code || '',
    };
  }
  return { name: article.name, code: article.external_code || article.code || '' };
};
